import { Badge, Button, Card, Col, ConfigProvider, Flex, Form, Input, Modal, Row, Select, Skeleton, Space, Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import StatusTag from "components/elements/TagCustom/StatusTag";
import FormAntd from "components/form/FormProvide/FormAntd";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { MailOutlined } from "@ant-design/icons";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { useForm } from "antd/es/form/Form";
import DownloadEmployeeSalaryModal from "./DownloadEmployeeSalaryModal";
import { SelectForm } from "components/form";
import { FormSelect } from "components/form/FormProvide";

const VerificationPage = ({
    PAYMENT_TAB = [],
    VERIFICATION_TYPE = [],
    getTable = () => { },
    getVisibleIcon = () => { },
    searchTxt = "",
    onChange = () => { },
    onSearch = () => { },
    onClearSearchTxt = () => { },
    payrollPeriod = {},
    isLoading = false,
    onEditPayroll = () => { },
    onPageTypeChange = () => { },
    updateHeaderStatusToApproval = () => { },
    updateHeaderStatusToCal = () => { },
    totalEmployeeTab = {},
    rowSelected = [],
    updateTxnPaymentStatusToCalculate = () => { },
    pageStatus = '0',
    onRejectModalOpen = () => { },
    getModal = () => { },
    sendSalaryCertificateFn = () => { },
    exportTxnPayment = () => { },
    exportPaymentSlip = () => { },
    modifiedExportStatusDropdown = () => { },
    onExportStatusChange = () => { },
    isModalSalaryOpen = false,
    setIsModalSalaryOpen = () => { },
    isDownload = false,
    isSlipDownload = false
}) => {
    const { t, i18n } = useTranslation()
    const [form] = useForm(null);
    const [form2] = useForm(null);
    const isSpecialPeriod = payrollPeriod?.specialPeriod == "Y"

    const refStatus = useRef(null)

    useEffect(() => {
        form.resetFields()
    }, [pageStatus, form])


    console.log("form2", form2.getFieldsValue(true));

    const MESSAGE = {
        DOWNLOAD_EMPLOYEE_SALARY_REPORT: i18n.language === 'en' ? "Confirm download of employee salary report?" : "ยืนยันการดาวน์โหลดรายงานเงินเดือนพนักงานหรือไม่",
        SEND_SALARY_CERTIFICATE_TO_EMPLOYEE: i18n.language === 'en' ? "Confirm sending of salary certificate to employees?" : "ยืนยันการส่งใบรับรองเงินเดือนไปยังพนักงานหรือไม่",
        REJECT_TO_RECAL: i18n.language === 'en' ? "Confirm sending back to recalculate employee salary?" : "ยืนยันการส่งกลับไปคำนวณเงินเดือนพนักงานขั้นตอนก่อนหน้าใหม่อีกครั้งหรือไม่"
    }



    return (
        <>
            {getModal()}
            <DownloadEmployeeSalaryModal
                isModalSalaryOpen={isModalSalaryOpen}
                setIsModalSalaryOpen={setIsModalSalaryOpen}
                exportTxnPayment={exportTxnPayment}
                exportPaymentSlip={exportPaymentSlip}
                isDownload={isDownload}
                isSlipDownload={isSlipDownload}
            />
            <Card style={{ backgroundColor: "#FCFCFC", borderRadius: "10px", border: "1px solid #D9D9D9", "height": "30vh", "width": "40vw" }}>
                {isLoading ? (
                    <Skeleton active={isLoading} />
                ) :
                    <Space direction='vertical' styles={{ "height": "20vh", "width": "30vw" }}>
                        <Row justify="space-between">
                            <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                {t("payment_period.label.period")} {dayjs(String(payrollPeriod?.month, "MM")).format('MMMM')} {isSpecialPeriod ? t("payment_period.label.special_period") : t("payment_period.label.period_no")} {payrollPeriod?.periodNo}
                            </span>
                            <StatusTag
                                value={payrollPeriod?.statusFlag}
                                text={(i18n.language === 'en' ? payrollPeriod?.statusNameEn : payrollPeriod?.statusName)}
                            />
                        </Row>
                        <Row style={{ gap: "32px" }}>
                            <Flex vertical>
                                <span style={{ color: "#42526D" }}>{t("payroll.employment_type_setup.header")}</span>
                                {payrollPeriod?.employmentType?.map((o) => (
                                    <span key={o?.id} style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                        {i18n.language === 'en' ? o?.employmentTypeNameEn : o?.employmentTypeName}
                                    </span>
                                ))}
                            </Flex>
                            <Flex vertical>
                                <span style={{ color: "#42526D" }}>{t("payroll.payroll_period")}</span>
                                <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                    {i18n.language === "en"
                                        ? (dayjs(payrollPeriod?.startPeriod).format("DD/MM/YYYY") + " - " + dayjs(payrollPeriod?.endPeriod).format("DD/MM/YYYY"))
                                        : (dayjs(payrollPeriod?.startPeriod).format("DD/MM/BBBB") + " - " + dayjs(payrollPeriod?.endPeriod).format("DD/MM/BBBB"))}
                                </span>
                            </Flex>

                            <Flex vertical>
                                <span style={{ color: "#42526D" }}>{t("payment_period.label.payment_date")}</span>

                                <Flex gap={8}>
                                    <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                        {i18n.language === "en"
                                            ? dayjs(payrollPeriod?.paymentDate).format("DD/MM/YYYY")
                                            : dayjs(payrollPeriod?.paymentDate).format("DD/MM/BBBB")}
                                    </span>
                                    {/* {payrollPeriod?.step === 0 && (
                                        <EditIcon style={{ fontSize: "16px", padding: 0, alignSelf: "center", cursor: "pointer" }} onClick={() => onEditPayroll()} />
                                    )} */}
                                </Flex>

                            </Flex>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Flex justify="space-between">
                                    <Flex vertical>
                                        <span style={{ color: "#42526D" }}>{t('payment.label.numberOfEmployee')}</span>
                                        <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                            {payrollPeriod?.numberOfEmployee ?? 0 + " " + t("expense.expense-detail.person")}
                                        </span>
                                    </Flex>
                                    <Flex vertical>
                                        <span style={{ color: "#42526D" }}>{t('payment.label.total')}</span>
                                        <span style={{ fontSize: "18px", color: "#42526D", fontWeight: "bold" }}>
                                            {get2DecimalPointsWithCommas(payrollPeriod?.netIncome) + " " + t('unit.baht')}
                                        </span>
                                    </Flex>

                                </Flex>

                            </Col>
                        </Row>
                    </Space>
                }
            </Card>

            <ConfigProvider
                theme={{
                    components: {
                        Tabs: {
                            itemHoverColor: "var(--tab-color)",
                            itemActiveColor: "var(--tab-color)"
                        },
                    },
                }}
            >
                <Tabs
                    onChange={(e) => {
                        onPageTypeChange(e);
                        form2?.setFieldValue('exportStatus', null);
                        // onExportStatusChange?.(null)
                    }}
                    tabBarStyle={{ justifyContent: 'space-between' }}
                >
                    {VERIFICATION_TYPE.map(tab => (
                        <TabPane
                            key={tab.key}
                            tab={
                                <Flex gap={8}>
                                    <span>{i18n.language === 'en' ? tab.nameEn : tab.name}</span>
                                    <Badge count={tab?.values} showZero />
                                </Flex>
                            }
                        />
                    ))}
                </Tabs>

            </ConfigProvider>
            <Row>
                <Col span={24}>
                    <Tabs
                        onChange={onChange}
                        tabBarStyle={{ justifyContent: 'space-between' }}
                    >
                        {payrollPeriod?.step >= 1 ? PAYMENT_TAB.filter((o) => ['all', 'editedItems'].includes(o.key)).map((tab) => (
                            <TabPane
                                key={tab.key}
                                tab={
                                    <Flex gap={8}>
                                        <span>{tab.label}</span>
                                        {['all', 'editedItems'].includes(tab.key) ? null : (
                                            <Badge count={tab?.values} showZero />
                                        )}
                                    </Flex>
                                }
                            />
                        )) : PAYMENT_TAB.map((tab) => (
                            <TabPane
                                key={tab.key}
                                tab={
                                    <Flex gap={8}>
                                        <span>{tab.label}</span>
                                        {['all', 'editedItems'].includes(tab.key) ? null : (
                                            <Badge count={tab?.values} showZero />
                                        )}
                                    </Flex>
                                }
                            />
                        ))}
                    </Tabs>

                    <Flex justify="space-between">
                        <Flex justify="start">
                            <FormAntd
                                form={form}
                                initialValues={{ searchTxt }}
                                onFinish={onSearch}

                            >
                                <Form.Item name="searchTxt" style={{ "width": "40vw" }} >
                                    <Flex gap={10} >
                                        <Input
                                            name="searchTxt"
                                            placeholder={i18n.language === 'en' ? "employee no / name / nameEn / surname / surnameEn" : "รหัสพนักงาน / ชื่อ / นามสกุล / ชื่อภาษาอังกฤษ / นามสกุลภาษาอังกฤษ"}
                                            style={{ "height": "5vh", width: "30vw" }}
                                        />
                                        <Button
                                            loading={isLoading}
                                            type="default"
                                            onClick={(e) => { onClearSearchTxt(e); form2?.resetFields(); onExportStatusChange?.(null) }}
                                            style={{ borderRadius: 8, "height": "5vh", "width": "6vw" }}
                                        >
                                            {t("common.clear").toUpperCase()}
                                        </Button>
                                        <Button
                                            title="1"
                                            loading={isLoading}
                                            type="primary"
                                            htmlType="submit"
                                            style={{ height: "5vh", width: "6vw", borderRadius: 8, backgroundColor: "var(--button-color)", }}
                                        >
                                            {/* <Flex justify="space-between"> */}
                                            {t("creatTamplete.Search").toUpperCase()}
                                            {/* </Flex> */}
                                        </Button>
                                    </Flex>
                                </Form.Item>
                            </FormAntd>
                        </Flex>
                        {/* <Flex align="center" justify="center" gap={8}>
                            <Select
                                name="exportStatus"
                                label={t("address.province")}
                                placeholder={t('please-select-1')}
                                size="large"
                                options={modifiedExportStatusDropdown}
                                allowClear
                                onChange={(values) => {
                                    onExportStatusChange(values)
                                }}
                            />
                        </Flex> */}
                        <Flex justify="end" gap={10}>
                            <FormAntd
                                form={form2}
                                initialValues={{ searchTxt }}
                                onFinish={onSearch}

                            >
                                <FormSelect
                                    ref={refStatus}
                                    style={{
                                        height: "45px"
                                    }}
                                    name="exportStatus"
                                    // label={t("address.province")}
                                    placeholder={t('please-select-1')}
                                    size="large"
                                    options={modifiedExportStatusDropdown}
                                    allowClear
                                    onChange={(values) => {
                                        onExportStatusChange(values)
                                    }}
                                />
                            </FormAntd>

                            <Button
                                type="default"
                                style={{
                                    padding: "8px 16px", height: 44, borderRadius: 8, display: "flex", alignItems: "center"
                                }}
                                // onClick={exportTxnPayment}
                                onClick={() => { setIsModalSalaryOpen(true) }
                                }
                                icon={<DownloadIcon style={{ fontSize: 16 }} />}
                            >
                                <span style={{ color: "#667085" }}>{t('payment.label.download_doc')}</span>
                            </Button>
                            {
                                // pageStatus === '1' ?
                                pageStatus === '1' && payrollPeriod?.step >= 1 ?
                                    // pageStatus === '1' && payrollPeriod?.step == 1 ?
                                    <Flex gap={10}>

                                        <Button
                                            type="default"
                                            style={{ padding: "8px 16px", height: 44, borderRadius: 8 }}
                                            // onClick={sendSalaryCertificateFn}
                                            onClick={() => {
                                                Modal.confirm({
                                                    title: t("dialog.confirmation.header"),
                                                    content: MESSAGE.SEND_SALARY_CERTIFICATE_TO_EMPLOYEE,
                                                    onOk() {
                                                        sendSalaryCertificateFn();
                                                    },
                                                    okText: t("common.confirm"),
                                                    cancelText: t("common.cancel"),
                                                });
                                            }}
                                        >
                                            <Flex align="center" justify="center" gap={8}>
                                                <MailOutlined />
                                                <span style={{ color: "#667085" }}>{t('payment.label.sendSlip')}</span>
                                            </Flex>
                                        </Button>
                                    </Flex>
                                    : null}
                            {/* <Button
                                type="default"
                                style={{ padding: "8px 16px", height: 44, borderRadius: 8 }}
                            >
                                <Flex align="center" justify="center" gap={8}>
                                    <FilterIcon />
                                    <span style={{ color: "#667085" }}>{t('common.filter')}</span>
                                </Flex>
                            </Button> */}
                            {getVisibleIcon()}
                        </Flex>
                    </Flex>

                    <Row>
                        <Col span={24}>{getTable()}</Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    {payrollPeriod?.step === 1 ?
                        <Flex gap="5px" justify="end">
                            {
                                pageStatus?.match("1.5|0") ?
                                    <Flex gap="5px">
                                        <Button
                                            style={{ borderRadius: "8px", height: "40px", backgroundColor: totalEmployeeTab?.countIncomplete > 0 ? "" : "var(--button-color)" }}
                                            type="primary"
                                            htmlType="submit"
                                            disabled={rowSelected?.length == 0}
                                            onClick={() => {
                                                Modal.confirm({
                                                    title: t("dialog.confirmation.header"),
                                                    content: MESSAGE.REJECT_TO_RECAL,
                                                    onOk() {
                                                        onRejectModalOpen();
                                                    },
                                                    okText: t("common.confirm"),
                                                    cancelText: t("common.cancel"),
                                                });
                                            }}
                                        >
                                            {t("payment.label.return-payroll")}
                                        </Button>
                                        <Button
                                            style={{ borderRadius: "8px", height: "40px", backgroundColor: totalEmployeeTab?.countIncomplete > 0 ? "" : "var(--button-color)" }}
                                            type="primary"
                                            htmlType="submit"
                                            disabled={rowSelected?.length == 0}
                                            onClick={() => {
                                                Modal.confirm({
                                                    title: t("dialog.confirmation.header"),
                                                    content: (
                                                        <>
                                                            <p>
                                                                {/* {t("payment.label.toVerify")} */}
                                                                {i18n.language === 'en' ? "Confirm salary verify ?" : "ยืนยันการตรวจสอบเงินเดือนหรือไม่ ?"}
                                                            </p>
                                                        </>
                                                    ),
                                                    onOk() {
                                                        updateTxnPaymentStatusToCalculate()
                                                    },
                                                    okText: t("common.confirm"),
                                                    cancelText: t("common.cancel"),
                                                });
                                            }}
                                        >
                                            {t("payment.label.toVerify")}
                                        </Button>

                                    </Flex> : null

                            }
                            {
                                pageStatus === "1" ?
                                    <Flex gap={'5px'}>

                                        {/* <Button
                                            style={{ borderRadius: "8px", height: "40px", backgroundColor: totalEmployeeTab?.countIncomplete > 0 ? "" : "var(--button-color)" }}
                                            type="primary"
                                            htmlType="submit"
                                            disabled={rowSelected?.length == 0}
                                            onClick={onRejectModalOpen}
                                        >
                                            {t("payment.label.return-payroll")}
                                        </Button> */}
                                        <Button
                                            style={{ borderRadius: "8px", height: "40px", backgroundColor: totalEmployeeTab?.countIncomplete > 0 ? "" : "var(--button-color)" }}
                                            type="primary"
                                            htmlType="submit"
                                            // disabled={payrollPeriod?.step !== 1}
                                            onClick={() => {
                                                Modal.confirm({
                                                    title: t("dialog.confirmation.header"),
                                                    content: (
                                                        <>
                                                            <p>
                                                                {t("payment.label.send-request-for-cal")}

                                                            </p>
                                                        </>
                                                    ),
                                                    onOk() {
                                                        updateHeaderStatusToCal()
                                                    },
                                                    okText: t("common.confirm"),
                                                    cancelText: t("common.cancel"),
                                                });
                                            }}
                                        >
                                            {t("payment.label.send-request-for-cal")}
                                        </Button>
                                        <Button
                                            style={{ borderRadius: "8px", height: "40px", backgroundColor: totalEmployeeTab?.countIncomplete > 0 ? "" : "var(--button-color)" }}
                                            type="primary"
                                            htmlType="submit"
                                            // disabled={payrollPeriod?.step !== 1}
                                            onClick={() => {
                                                Modal.confirm({
                                                    title: t("dialog.confirmation.header"),
                                                    content: (
                                                        <>
                                                            <p>
                                                                {t("payment.label.send-request-for-approve")}

                                                            </p>
                                                        </>
                                                    ),
                                                    onOk() {
                                                        updateHeaderStatusToApproval()

                                                    },
                                                    okText: t("common.confirm"),
                                                    cancelText: t("common.cancel"),
                                                });
                                            }}
                                        >
                                            {t("payment.label.send-request-for-approve")}
                                        </Button>
                                    </Flex> : null
                            }

                        </Flex> : null}
                </Col>
            </Row>
        </>
    )
}

export default VerificationPage